var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.332 7.293h-66.664c-0.58594 0-1.043 0.45703-1.043 1.0391v83.332c0 0.58203 0.45703 1.043 1.043 1.043h66.668c0.58203 0 1.043-0.45703 1.043-1.043l-0.003906-83.332c0-0.58203-0.45703-1.0391-1.043-1.0391zm-1.0391 83.332h-64.582v-81.25h64.582z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.168 67.707h41.668c0.58203 0 1.043-0.45703 1.043-1.043v-4.168c0-8.1875-4.5625-15.605-11.75-19.375 3.3555-2.875 5.5-7.125 5.5-11.875 0-8.625-7-15.625-15.625-15.625s-15.625 7-15.625 15.625c0 4.75 2.1445 9 5.5 11.875-7.1875 3.7695-11.75 11.188-11.75 19.375v4.168c-0.003906 0.58594 0.45312 1.043 1.0391 1.043zm7.2891-36.457c0-7.457 6.082-13.543 13.543-13.543 7.457 0 13.543 6.082 13.543 13.543 0 7.457-6.082 13.543-13.543 13.543-7.457 0-13.543-6.0859-13.543-13.543zm-6.25 31.25c0-7.75 4.543-14.75 11.582-17.98 2.3945 1.4805 5.1875 2.3555 8.207 2.3555 3.0195 0 5.8125-0.875 8.207-2.3555 7.043 3.2305 11.582 10.207 11.582 17.98v3.125h-39.582z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 76.043h50c0.58203 0 1.043-0.45703 1.043-1.043 0-0.58203-0.45703-1.043-1.043-1.043h-50c-0.58203 0-1.043 0.45703-1.043 1.043 0 0.58203 0.46094 1.043 1.043 1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 84.375h50c0.58203 0 1.043-0.45703 1.043-1.043 0-0.58203-0.45703-1.043-1.043-1.043l-50 0.003907c-0.58203 0-1.043 0.45703-1.043 1.043 0 0.58203 0.46094 1.0391 1.043 1.0391z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderDefault);
export default __webpack_public_path__ + "static/media/provider-default.5de7e32ab715791d7311eb55ed909c01.svg";
export { ForwardRef as ReactComponent };